<script>
  import { page } from "$app/stores";
  import { onMount } from "svelte";
  /**@type {number}*/
  let date;

  onMount(() => {
    date = new Date().getFullYear();
  });
</script>

<footer>
  {#if $page.route.id !== '/'}
    <div class="text-shipping">
      <p><strong>SHOP NOW! FREE DELIVERY</strong> ON ALL ORDERS OVER £25!</p>
    </div>
  {/if}
  <div class="footer-content">
    <div class="top-footer">
      <div class="logo">
        <a href="/">
          <img src="/images/footer/logo.svg" alt="red carpet manicure logo" />
        </a>
      </div>
      <div class="follow-content">
        <p>FOLLOW <strong>US</strong></p>
        <div class="follow-us">
          <a href="https://www.tiktok.com/@redcarpetmanicure_uk" target="_blank" >
            <img src="/images/footer/tiktok.svg" alt="youtube social media" />
          </a>
          <a href="https://www.facebook.com/RedCarpetManicureUK" target="_blank">
            <img src="/images/footer/facebook.svg" alt="youtube social media" />
          </a>
          <a href="https://www.instagram.com/redcarpetmanicure_uk" target="_blank">
            <img src="/images/footer/instagram.svg" alt="youtube social media" />
          </a>
        </div>
      </div>
    </div>
    <div class="bottom-footer">
      <ul>
        <li><a href="/">HOME</a></li>
        <li><a href="/about-us">ABOUT US</a></li>
        <li><a href="/how-to">HOW TO VIDEO</a></li>
        <li><a href="/social">SOCIAL</a></li>
        <li><a href="/video">VIDEOS</a></li>
        <li><a href="/faq-s">FAQ’S</a></li>
        <li><a href="/privacy-policy">PRIVACY</a></li>
        <!-- <li><a href="/shipping-returns">SHIPPING & RETURNS</a></li> -->
        <li><a href="/terms-conditions">TERMS & CONDITIONS</a></li>
        <!-- <li><a href="/warrantyregistration/index">WARRANTY REGISTRATION</a></li>  -->
      </ul>
      <p class="copy">
        The RC RED CARPET MANICURE marks are owned by Nail Alliance, LLC, and
        are used herein pursuant to a license from Nail Alliance, LLC. <br/>&copy;{date} Red Carpet Manicure, LLC
      </p>
    </div>
  </div>
</footer>

<style>
  footer {
    position: relative;
    background-color: var(--red);
    color: var(--white);
    height: 100%;
    max-height: 61.3rem;
    z-index: 99;
  }
  .text-shipping {
    width: 100svw;
    padding: 10rem 0;
    background-color: var(--low-pink);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .text-shipping p {
    text-align: center;
    color: var(--pink);
    font-size: clamp(2.5rem, 4svw, 6rem);
    line-height: 1;
  }
  .text-shipping p strong {
    font-weight: 700;
  }
  .footer-content {
    width: 100svw;
    padding: 3rem 0 6rem 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 6.4rem;
    background-color: var(--red);
  }
  .top-footer {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    color: var(--white);
    position: relative;
    width: 80%;
    height: 34.5rem;
  }
  .top-footer::before {
    content: "";
    height: 90%;
    width: 0.5rem;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: var(--white);
    border-radius: 1rem;
  }
  .logo {
    width: 32rem;
    height: 100%;
  }
  .follow-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 32rem;
  }
  .follow-content p {
    font-size: 6.5rem;
    font-weight: 400;
  }
  .follow-content p strong {
    font-weight: 700;
  }
  .follow-us {
    display: flex;
    width: 100%;
    justify-content: space-evenly;
    align-items: center;
  }
  .follow-us a {
    display: flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;
    width: 5rem;
    height: 5rem;
    aspect-ratio: 1/1;
    background-color: var(--white);
    border-radius: 100%;
  }
  .follow-us a.x img {
    width: 50%;
    height: 50%;
  }
  .bottom-footer {
    height: 100%;
    background-color: var(--red);
  }
  .bottom-footer ul {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: min-content;
    flex-wrap: wrap;
  }
  .bottom-footer ul li {
    list-style: none;
    margin: 0.5rem 1.5rem;
    cursor: pointer;
  }
  .bottom-footer ul li a {
    color: var(--white);
    text-wrap: none;
    font-size: 2.8rem;
  }
  .copy {
    font-size: 1.5rem;
    text-align: center;
    line-height: 1.2;
    padding: 3.5rem 0 0 0;
  }
  @media (max-width: 820px) {
    .top-footer {
      justify-content: space-between;
      width: 90%;
    }
  }
  @media (max-width: 767px) {
    .top-footer {
      flex-direction: column;
    }
    .top-footer::before {
      width: 100%;
      height: 0.5rem;
      top: 53%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    .logo {
      width: 22rem;
    }
    .follow-content p {
      font-size: 4rem;
    }
    .bottom-footer ul li {
      margin: 0.5rem 0.8rem;
    }
    .bottom-footer ul li a {
      font-size: 2rem;
    }
  }
</style>
